<template>
	<div v-if="item" class="inquriy-detail-container u-container">
		<table class="inquiry-view-table">
			<colgroup>
				<col class="inquiry-view-table__col-title" />
				<col />
			</colgroup>
			<tbody>
				<tr>
					<th scope="row">접수일</th>
					<td>{{ item.datetime }}</td>
				</tr>
				<tr>
					<th scope="row">접수상태</th>
					<td>
						<span class="u-color-red">{{ statusApplication }}</span>
					</td>
				</tr>
				<tr>
					<th scope="row">이름</th>
					<td>{{ item.ar_name }}</td>
				</tr>
				<tr>
					<th scope="row">연락처</th>
					<td>{{ item.ar_hphone }}</td>
				</tr>
				<tr>
					<th scope="row">이메일</th>
					<td>{{ item.ar_email }}</td>
				</tr>
				<tr>
					<th scope="row">상담유형</th>
					<td>{{ item.ar_type }}</td>
				</tr>
				<tr>
					<th scope="row">희망지점</th>
					<td>{{ inquiryShopName }}</td>
				</tr>
			</tbody>
		</table>

		<div class="my-4">
			<!-- 문의 내용 -->
			<DetailCard>
				<template v-slot:title>
					<span class="u-font-weight-500">{{ item.ar_title }}</span>
				</template>
				<template v-slot:content>
					<div class="inquiry-detail-content">
						<div v-html="inquiryContent"></div>
					</div>
				</template>
			</DetailCard>

			<!-- 관리자 댓글 -->
			<div class="mt-2">
				<DetailCard v-for="reply in replyList" :key="reply.id">
					<template v-slot:title>
						<span class="px-1"><i class="ri-reply-fill"></i></span>
						{{ reply.reply_name }} : {{ reply.datetime }}
					</template>
					<template v-slot:content>
						<div class="inquiry-detail-content">
							<div v-html="formatReplyContent(reply.reply_content)"></div>
						</div>
					</template>
				</DetailCard>
			</div>
		</div>

		<!-- 버튼 -->
		<div class="inquriy-detail-buttons">
			<div class="columns">
				<div class="column col-6">
					<BaseBtn @click="goToEdit" color="primary" x-large block
						>수정</BaseBtn
					>
				</div>
				<div class="column col-6">
					<BaseBtn @click="clickDeletePost" color="thirdly" x-large block
						>삭제</BaseBtn
					>
				</div>
				<div class="column col-12 mt-2">
					<BaseBtn @click="goToList" color="secondary" medium block
						>목록</BaseBtn
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import DetailCard from '@/components/common/DetailCard';
import BaseBtn from '@/components/common/Btn';

import { convertLineBreakToHtml } from '@/utils/util';

export default {
	components: {
		DetailCard,
		BaseBtn,
	},
	computed: {
		arId() {
			return this.$route.params.id;
		},
		userId() {
			return this.$store.getters['userStore/userId'];
		},
		item() {
			return this.$store.getters['inquiryStore/userInquiryDetail'];
		},
		statusApplication() {
			return Number(this.item.ar_reply) > 0 ? '접수완료' : '대기';
		},
		inquiryShopName() {
			/**
			 * ar_shop3 : 지역명
			 * ar_shop2 : 지점명
			 */

			// case 1 : 지역만 선택했을 경우
			if (this.item.ar_shop3 !== '' && this.item.ar_shop2 === '')
				return `${this.item.ar_shop3} / 지점 선택안함`;

			// case 2 : 지역과 지점 모두 선택했을 경우
			if (this.item.ar_shop3 !== '' && this.item.ar_shop2 !== '')
				return `${this.item.ar_shop3} / ${this.item.ar_shop2}`;

			// case 3 : 그 외
			return '지점 선택안함';
		},
		replyList() {
			return this.$store.getters['inquiryStore/userInquiryReplyList'];
		},
		inquiryContent() {
			return this.item.ar_content
				? this.item.ar_content.replace(/\\'/g, "'")
				: '';
		},
	},
	created() {
		this.fetchUserInquiryDetail().then(({ data }) => {
			if (data.code === '00000') {
				this.fetchUserInquiryReplyList();
			} else {
				const alertOptions = {
					message: data.message || '게시물이 삭제되었거나 존재하지 않습니다.',
				};
				this.showAlert(alertOptions).then(({ ok }) => {
					if (ok === true) {
						this.$router.push({ name: 'inquiry' });
					}
				});
			}
		});
	},
	methods: {
		async fetchUserInquiryDetail() {
			const payload = {
				arId: this.arId,
				userId: this.userId,
			};

			return await this.$store.dispatch(
				'inquiryStore/getUserInquiryDetail',
				payload,
			);
		},
		async fetchUserInquiryReplyList() {
			const payload = {
				arId: this.arId,
			};

			return await this.$store.dispatch(
				'inquiryStore/getUserInquiryReplyList',
				payload,
			);
		},
		formatReplyContent(content) {
			return convertLineBreakToHtml(content);
		},
		goToList() {
			this.$router.push({ name: 'inquiry' });
		},
		goToEdit() {
			this.$router.push({
				name: 'inquiryEdit',
				params: { id: this.item.ar_id },
			});
		},
		clickDeletePost() {
			const options = {
				message: '게시물을 삭제하시겠습니까?',
			};
			this.showConfirm(options).then(({ ok }) => {
				if (ok === true) {
					this.deletePost();
				}
			});
		},
		async deletePost() {
			const payload = {
				arId: this.arId,
				userId: this.userId,
			};

			await this.$store
				.dispatch('inquiryStore/deleteUserInquiry', payload)
				.then(({ data }) => {
					if (data.code === '00000') {
						this.$store.dispatch('inquiryStore/getUserInquiryList');
						this.$router.push({ name: 'inquiry' });
					} else {
						const options = {
							message: data.message || '게시물 삭제에 실패했습니다.',
						};
						this.showAlert(options);
					}
				});
		},
	},
};
</script>

<style scoped>
.inquriy-detail-container {
	padding: 1.875rem 0;
}

.inquiry-view-table {
	width: 100%;
}

.inquiry-view-table__col-title {
	width: 26%;
}

.inquiry-view-table th,
.inquiry-view-table td {
	height: 38px;
	vertical-align: middle;
	border-bottom: 1px solid #c8c8c8;
	font-size: 0.875rem;
	text-align: left;
}

.inquiry-view-table th {
	padding: 0 0.5rem;
	border-right: 1px dashed #ccc;
}

.inquiry-view-table tr:last-child th,
.inquiry-view-table tr:last-child td {
	border-bottom: 0;
}

.inquiry-view-table td {
	padding: 0 1.25rem;
}

/* 문의 내용 */
.inquiry-detail-title {
	font-weight: 500;
}

.inquiry-detail-content {
	color: #666;
	font-size: 0.8125rem;
	font-weight: 300;
}

.inquriy-detail-buttons {
	padding: 0 0.25rem;
}
</style>
